import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class RutaService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerCombo(inputParams: {
    entidad: {
      empresa_rut: number,
      sucursal_codigo: number,
      tipobusqueda: number
    },
    // paginaActual: number,
    // cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: rutaInputType) {
          ruta {
            obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: 1, cantidadRegistrosPorPagina: -1) {
              mensajes {
                tipo
                texto
                codigo
                contexto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  descripcion
                  sucursal_codigo
                  empresa_rut
                  estado
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.ruta.obtenerSegunFiltro
        callback({ mensajes, respuesta })
      }
    );
  }
}
